import styled from 'styled-components';

export const OrglessHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 0 30px;
    width: 100%;
    height: 50px;  
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 177px);
  padding: 20px; 
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 800px;
  height: 300px;
  padding: 20px;
`;

export const LogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 200px;
    border-right: 1px solid #ccc;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 12px;
  gap: 12px;
`;

export const Title = styled.h1`
    font-size: 18px;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
`;

export const Description = styled.p`
    font-size: 14px;
    margin: 0;
    text-align: center;
    max-width: 464px;
    font-weight: 400;
    color: #52525B;
`;

export const ContactText = styled.p`
    font-size: 20px;
    line-height: 1.2;
    color: #4b4949;
    margin-bottom: 12px;
    color: #000000;
    text-align: center;
    a {
        text-align: center;
        color: #52525B; 
        text-decoration: underline;
        margin: 0 5px;
    }
`;

export const Contact = styled.span`
    color: #52525B;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 400;
    margin-bottom: 40px;
    text-align: center;
`;

export const Link = styled.a`
    color: #C18244;
    font-size: 18px;
    line-height: 1.2;
    font-weight: 400;
    text-decoration: underline;
`;

export const Button = styled.button`
    background-color: #fff;
   width: 100%;
    max-width: 300px;
    height: 40px;
    border-radius: 50px;
    color: #000;
    border:1px solid #000;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 400;
    cursor: pointer;
    margin: 10px 0;
`;

export const OrglessFooter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    padding: 0 30px;
    border-top: 1px solid #f5f5f5;
    
    a {
        color: #989898;
        font-size: 12px;
        line-height: 1.7;
        position: relative;
        &:not(:last-child) {
            &:after {
                content: '|';
                margin-left: 10px;
                margin-right: 10px;
            }
        }
        &:hover {
            color: #4b4949;
            text-decoration: underline;
        }
    }
`;
